import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { setWindowLocation } from 'js-utils/http';
import { Select } from '@eb/eds-select';
import { constants, types } from '@eb/event-create-publish-utils';
import { getMyEventLink } from '../../utils';

const { SERIES_CHILD_PROPTYPES, EVENT_IDS_PROPTYPES } = types;
const { EVENT_HEADER_SERIES_DROPDOWN_ID, MANAGE_TEXTS } = constants;
const DROPDOWN_MOBILE_CLASSES =
    'eds-g-group eds-g-cell-12-12 eds-g-cell-sm-8-12 eds-g-cell-sw-6-12 eds-g-cell-mn-6-12 eds-show-down-mn eds-align--center eds-l-mar-top-4 eds-l-mar-bot-1';
const DROPDOWN_DESKTOP_CLASSES =
    'eds-g-group eds-g-cell-4-12 eds-g-cell-md-6-12 eds-g-cell-mw-6-12 eds-show-up-md eds-l-mar-top-4 eds-l-mar-bot-1';
const DROPDOWN_AND_LINK_STYLE = { width: '100%', textAlign: 'left' };

const getSelectedValue = (eventId, isSeriesChild, seriesChildren, parentId) => {
    let activeText = getMyEventLink(parentId);

    if (isSeriesChild) {
        const currentEvent = _.find(seriesChildren, { eventId });

        if (currentEvent) {
            activeText = getMyEventLink(eventId);
        }
    }

    return activeText;
};

const getSelectValues = (parentId, seriesChildrenData) => {
    const selectParentValue = [
        {
            value: getMyEventLink(parentId),
            display: MANAGE_TEXTS.allDates,
        },
    ];
    let childSelectValues;

    if (seriesChildrenData) {
        childSelectValues = seriesChildrenData.map((seriesChild) => {
            let formattedDateTime = seriesChild.childDateTimeStart;

            if (seriesChild.isCanceled) {
                formattedDateTime += ` ${MANAGE_TEXTS.canceled}`;
            }

            return {
                value: getMyEventLink(seriesChild.eventId),
                display: formattedDateTime,
            };
        });
    }

    return selectParentValue.concat(childSelectValues);
};

const getQuickLink = (isSeriesChild, parentId, seriesUpcomingEventId) => {
    // Default text and link to next up coming event
    let manageDateText = MANAGE_TEXTS.upcomingDate;
    let manageDateLink = getMyEventLink(seriesUpcomingEventId);

    if (isSeriesChild) {
        // If event is a series child, change link and text to manage all events
        manageDateText = MANAGE_TEXTS.allDates;
        manageDateLink = getMyEventLink(parentId);
    }

    // If event is a child or the last event hasn't ended:
    if (isSeriesChild || seriesUpcomingEventId) {
        return (
            <p className="eds-text-color-ui-blue eds-text-bm eds-text--left">
                <a href={manageDateLink}>{manageDateText}</a>
            </p>
        );
    }

    // No link is shown when viewing the parent event, and all events have ended
    return null;
};

export default class EventHeaderSeriesDropdown extends PureComponent {
    static propTypes = {
        eventIds: EVENT_IDS_PROPTYPES.isRequired,
        isSeriesChild: PropTypes.bool.isRequired,
        seriesChildrenData: SERIES_CHILD_PROPTYPES,
    };

    _handleOnChange(eventUrl) {
        setWindowLocation(eventUrl);
    }

    render() {
        const { eventIds, isSeriesChild, seriesChildrenData } = this.props;
        const { eventId, parentId, seriesUpcomingEventId } = eventIds;
        const selectedValue = getSelectedValue(
            eventId,
            isSeriesChild,
            seriesChildrenData,
            parentId,
        );
        const quickLink = getQuickLink(
            isSeriesChild,
            parentId,
            seriesUpcomingEventId,
        );
        const selectValues = getSelectValues(parentId, seriesChildrenData);
        const dropdownAndLink = (
            <div style={DROPDOWN_AND_LINK_STYLE}>
                <Select
                    id={EVENT_HEADER_SERIES_DROPDOWN_ID}
                    value={selectedValue}
                    values={selectValues}
                    onChange={this._handleOnChange.bind(this)}
                />
                {quickLink}
            </div>
        );

        return (
            <div className="eds-g-grid">
                <div className={DROPDOWN_MOBILE_CLASSES}>{dropdownAndLink}</div>
                <div className={DROPDOWN_DESKTOP_CLASSES}>
                    {dropdownAndLink}
                </div>
            </div>
        );
    }
}
